export default "__VITE_ASSET__BNTeDtWO__"